export default "__VITE_ASSET__ByRqbOYj__"